import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";
import { filter } from "lodash-es";

import { MESSAGE_ACTION_TYPE } from "./message.action";
import { MessageState } from "./message.model";

const initialState: MessageState = {
	messages: [],
};

export function messageReducer(state = initialState, action: ActionWithPayload): MessageState {
	switch (action.type) {
		case MESSAGE_ACTION_TYPE.add: {
			return updateState(state, {
				messages: [...state.messages, action.payload],
			});
		}
		case MESSAGE_ACTION_TYPE.clearByMessageCode: {
			const messages = filter(state.messages, (message) => message.messageCode !== action.payload);

			if (messages.length === state.messages.length) {
				return state;
			}

			return updateState(state, {
				messages,
			});
		}
		case MESSAGE_ACTION_TYPE.clearByContext: {
			const messages = filter(state.messages, (message) => message.context !== action.payload);

			if (messages.length === state.messages.length) {
				return state;
			}

			return updateState(state, {
				messages,
			});
		}
		case MESSAGE_ACTION_TYPE.clearAll: {
			if (!state.messages.length) {
				return state;
			}

			return updateState(state, {
				messages: [],
			});
		}
		default:
			return state;
	}
}
